module.exports = __webpack_public_path__ + "img/19_61.45c911db.png";